import { motion } from "framer-motion";
import { HEADSHOTS } from "@/content";
import { useLanguage } from "@/lang";
import { SectionHeading } from "./SectionHeading";

export const Headshots = () => {
  const { copy } = useLanguage();

  return (
  <section id="headshots" data-testid="headshots-section" className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
    <SectionHeading {...copy.headings.headshots} />

    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
      {HEADSHOTS.map((shot, i) => (
        <motion.figure
          key={shot.label}
          data-testid={`headshot-${shot.label.toLowerCase()}`}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
          className={`group relative overflow-hidden border border-white/10 ${shot.span}`}
        >
          <div className={`${shot.ratio} overflow-hidden`}>
            <img
              src={shot.src}
              alt={`Clive Bucher Headshot — ${shot.label}`}
              loading="lazy"
              className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-[1.04] transition-[filter,transform] duration-700 ease-out"
            />
          </div>
          <figcaption className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-5 py-4 bg-black/50 backdrop-blur-md border-t border-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <span className="text-xs uppercase tracking-[0.25em] text-zinc-300">{shot.label}</span>
            <span className="font-display italic text-sm text-zinc-500">Clive Bucher</span>
          </figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
  );
};
